export default {
  'label/end_of_trial_counter': 'Seu período de teste acabou.',
  'label/end_of_trial_subscribe_now': 'Assine Agora!',
  'label/trialing_counter': 'Restam {0} dias do seu teste grátis.',
  'label/trialing_counter_one': 'Resta 1 dia do seu teste grátis.',
  'label/trialing_counter_today': 'Seu teste grátis termina hoje.',
  'label/trialing_subscribe_now': 'Assine agora!',
  'label/credit_card/payment_success_title': 'Tudo certo! Você já pode usar o Doutore :)',
  'label/credit_card/payment_success_text': 'Sua assinatura já está ativa! Qualquer sugestão, dúvida ou problema, nosso canal de atendimento via email estará sempre disponível.',
  'action/select_a_plan': 'Escolha um Plano',
  'action/choose_plan': 'Assinar',
  'action/payment_success_back': 'Voltar ao Doutore',
  'label/quest_have_clinic': 'Você possui uma Clínica?',
  'action/contact': 'Entre em contato',
  'label/plans': 'Planos',
  'label/web_checkout_note': 'Você conclui a assinatura no navegador, com pagamento seguro por cartão de crédito.',
  'label/web_checkout_pending/title': 'Conclua sua assinatura no navegador',
  'label/web_checkout_pending/text': 'Abrimos a página de pagamento do Doutore no seu navegador. Quando terminar, é só voltar para o app: liberamos seu acesso na hora.',
  'action/web_checkout_done': 'Já assinei',
  'action/web_checkout_reopen': 'Abrir o pagamento de novo',
  'label/web_checkout_pending/unconfirmed': 'Ainda não recebemos a confirmação do pagamento. Se você já pagou, confira sua internet e toque em "Já assinei" de novo.',
  'label/checking_subscription': 'Verificando...',
  'label/opening_checkout': 'Abrindo...',
  'label/pricing_title': 'Escolha seu plano',
  'label/pricing_subtitle': 'Todos os planos incluem pacientes e secretárias ilimitados, treinamento e acesso pelo computador, iPhone e Android.',
  'label/sms_addon_note': 'Confirmação automática de consultas por SMS disponível, cobrada à parte por mensagem enviada.',
  'label/most_popular': 'Mais popular',
  'label/per_month': '/mês',
  'label/included_in': 'O que vem no plano {0}',
  'label/tagline/basic': 'Agenda e prontuário para organizar o consultório.',
  'label/tagline/complete': 'O consultório completo, do receituário ao financeiro.',
  'label/tagline/concierge': 'Para quem atende em várias clínicas e quer prioridade.',
  'label/feature/agenda_records': 'Agenda e prontuário eletrônico',
  'label/feature/one_professional': '1 profissional de saúde',
  'label/feature/chat_email_support': 'Suporte por chat e email',
  'label/feature/everything_in_basic': 'Tudo do Básico, e mais:',
  'label/feature/e_prescriptions': 'Receituário eletrônico',
  'label/feature/forms': 'Anamnese e outros formulários',
  'label/feature/financial': 'Controle financeiro',
  'label/feature/storage_20gb': '20 GB de armazenamento',
  'label/feature/everything_in_complete': 'Tudo do Completo, e mais:',
  'label/feature/custom_forms': 'Formulários personalizados',
  'label/feature/multiple_clinics': 'Controle de várias clínicas',
  'label/feature/storage_100gb': '100 GB de armazenamento',
  'label/feature/priority_support': 'Suporte prioritário por chat, email e WhatsApp',
  'label/clinic_cta_text': 'Montamos um plano para a sua equipe, com vários profissionais.',
  'label/web_checkout_short': 'Pagamento seguro no navegador',
  'action/subscribe_plan': 'Assinar {0} · {1}/mês',
  // An iOS build in App Store review: no plans, prices or purchase
  'store_review/trialing_title': 'Você está no período de teste',
  'store_review/ended_title': 'Seu acesso ao Doutore não está ativo',
  'store_review/ended_text': 'Se precisar de ajuda com a sua conta, fale com a nossa equipe.',
  'store_review/support': 'Falar com o suporte',
  'store_review/logout': 'Sair do Doutore',
};
